module.exports = __webpack_public_path__ + "media/luxury-2026/round-hill-estate-aerial-203e9dd0.jpg";